import { HttpBadStatusCodeError } from '@cian/peperrors';
import { ISynchronizationSyncChat } from '../../repositories/newbuilding-consultants/entities/synchronization_sync_chat/SynchronizationSyncChat';
import {
  fetchGetOrCreateChat,
  TGetOrCreateChatResponse,
} from '../../repositories/newbuilding-consultants/v1/get-or-create-chat';
import { ResponseError } from '../../utils/errors';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

interface IConsultantChatProps {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: {
    pageUrl?: null | string;
  };
}

export const getConsultantChat = async ({
  httpApi,
  logger,
  parameters,
}: IConsultantChatProps): Promise<ISynchronizationSyncChat | null> => {
  try {
    const data: TGetOrCreateChatResponse = await fetchGetOrCreateChat({
      httpApi,
      parameters,
    });

    if (data.statusCode !== 200) {
      throw new ResponseError({
        domain: 'resolveConsultantChat',
        message: data.response.message as string,
      });
    }

    return data.response.chat || null;
  } catch (error) {
    if (error.constructor.name === 'HttpTimeoutError') {
      logger.warning(error, {
        domain: 'resolveConsultantChat',
      });
    } else {
      logger.error(error, {
        domain: 'resolveConsultantChat',
      });
    }

    throw new HttpBadStatusCodeError(error);
  }
};
